import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=37b1842c&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./ImageViewer.vue?vue&type=style&index=1&id=37b1842c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1842c",
  null
  
)

export default component.exports